'use es6';

import { needsAuth } from '../../utils/authUtils';
import noAuthClient from 'hub-http/clients/noAuthApiClient';
import client from 'hub-http/clients/apiClient';
export { noAuthClient };
export default needsAuth() ? client : noAuthClient;